import { render, staticRenderFns } from "./userDataChange.vue?vue&type=template&id=3b510c8c&scoped=true&"
import script from "./userDataChange.vue?vue&type=script&lang=js&"
export * from "./userDataChange.vue?vue&type=script&lang=js&"
import style0 from "./userDataChange.vue?vue&type=style&index=0&id=3b510c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b510c8c",
  null
  
)

component.options.__file = "userDataChange.vue"
export default component.exports